// You can customize the template with the help of this file

//Template config options

// ** Logos servidos desde el bundle, no desde el CDN: los PNG viven en el repo
import logoDark from "@src/assets/images/logo/BlockPay-dark.png"
import logoWhite from "@src/assets/images/logo/BlockPay-white.png"

const ThemeConfig = () => {

  const skin = localStorage.getItem('skin')

  const themeConfig = {
    app: {
      appName: "",
      appLogoImage: skin === '"dark"' ? logoWhite : logoDark
    },
    layout: {
      isRTL: false,
      skin: "light", // light, dark, bordered, semi-dark
      type: "vertical", // vertical, horizontal
      contentWidth: "boxed", // full, boxed
      menu: {
        isHidden: false,
        isCollapsed: false
      },
      navbar: {
        // ? For horizontal menu, navbar type will work for navMenu type
        // El diseño usa un header pegado arriba, a todo el ancho y con borde inferior.
        // "floating" lo dibujaba como una card despegada con esquinas redondeadas.
        type: "sticky", // static , sticky , floating, hidden
        backgroundColor: "white" // BS color options [primary, success, etc]
      },
      footer: {
        type: "static" // static, sticky, hidden
      },
      customizer: false,
      scrollTop: true, // Enable scroll to top button
      toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
    }
  }

  return {
    themeConfig
  }
}


export default ThemeConfig
